module.exports = __webpack_public_path__ + "img/15.98d9c2ba.png";